import InfoButton from '../../../components/InfoButton/InfoButton'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'
import '../Section.css'

function GentleReminderTime() {
  return (
    <div className="dashboard-section">
      <h1>
        Gentle Reminder Time
        <InfoButton
          title="Gentle Reminder Time"
          content={
            <div>
              <p>
                Send gentle reminders to guests who haven't RSVP'd yet. Because people forget — 
                yes, even close friends. Keep it friendly, keep it simple.
              </p>
              <p>
                <strong>Features:</strong>
              </p>
              <ul>
                <li>See who hasn't responded yet</li>
                <li>Send personalized reminder messages</li>
                <li>Schedule automatic reminders</li>
                <li>Track reminder history</li>
                <li>Customize reminder templates</li>
              </ul>
              <p>
                A gentle nudge goes a long way — without being pushy.
              </p>
            </div>
          }
        />
      </h1>
      <ComingSoon messageIndex={1} />
    </div>
  )
}

export default GentleReminderTime
